<template>
    <div>
        <ubi-panel>
            <el-container>
                <el-aside width="25%"><h3>{{ $t("posts.edit.tariffTitle") }}</h3>
                    <p class="text-justify">{{ $t("posts.edit.fillAdPriceDetails") }}</p></el-aside>
                <el-container>
                    <el-main>
                        <el-row v-if="!isCmiste">
                            <el-col :span="12">
                                <el-form-item :label="$labels.mandat_type">
                                    <el-radio-group v-model="post.mandat_type">
                                        <el-radio
                                                v-for="mandatTypeChoice in this.$parent.getChoices('mandat_type')"
                                                :key="mandatTypeChoice"
                                                :label="mandatTypeChoice"
                                                :value="mandatTypeChoice">
                                        </el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <el-row :gutter="20">
                            <el-col :span="8">
                                <el-form-item :label="$t('posts.priceWithoutTaxes')" prop="prix_hors_taxe">
                                    <el-input v-model="post.prix_hors_taxe">
                                        <template slot="append">{{getDevise}}</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item :label="$t('posts.edit.landPricePart')" prop="prix_terrain">
                                    <el-input v-model="post.prix_terrain">
                                        <template slot="append">{{getDevise}}</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item :label="$t('posts.edit.ancillaryCostsPart')" prop="frais_annexes">
                                    <el-input v-model="post.frais_annexes">
                                        <template slot="append">{{getDevise}}</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <div v-if="getSitimmoUser.reseau == 'ARLOGIS'">
                            <el-row :gutter="20">
                                <el-col :span="8">
                                    <el-form-item :label="$labels.alur_pourcentage_honoraires_ttc"
                                                  prop="alur_pourcentage_honoraires_ttc">
                                        <el-input v-model="post.alur_pourcentage_honoraires_ttc">
                                            <template slot="append">%</template>
                                        </el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row :gutter="20">
                                <el-col :span="8">
                                    <el-form-item :label="$labels.taxe_fonciere"
                                                  prop="taxe_fonciere">
                                        <el-input v-model="post.taxe_fonciere">
                                            <template slot="append">{{getDevise}}</template>
                                        </el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </div>
                        <el-row>
                        </el-row>
                        <el-row>
                          <el-col :span="24">
                            <div class="block">
                              <el-form-item :label="$labels.frais_notaire" prop="frais_notaire">
                                <el-input   v-mask="'#################'" v-model.number="post.frais_notaire" type="frais_notaire" style="width: 50%">
                                  <div slot="append">{{ getDevise }}</div>
                                </el-input>
                              </el-form-item>
                            </div>
                          </el-col>
                          <el-col :span="6">
                            <div class="block">
                              <el-form-item :label="$labels.taux_tva" prop="taux_tva">
                                <el-input v-model="post.taux_tva" type="number" step="0.01" />
                              </el-form-item>
                            </div>
                          </el-col>
                        </el-row>
                    </el-main>
                </el-container>
            </el-container>
        </ubi-panel>
    </div>
</template>

<script>
import { getDefinitionDonneeListeeByCode } from '@/services/posts'
import { mapGetters } from 'vuex'

export default {
  name: 'PostEditImmoOfferH',
  props: ['post', 'ddList'],
  data () {
    return {}
  },
  computed: {
    ...mapGetters(['getSitimmoUser']),
    getDevise () {
      return this.$store.getters['donnees/getDevise']
    },
    sitimmoUser () {
      return this.$store.getters.getSitimmoUser
    },
    userJob () {
      return this.sitimmoUser.metier
    },
    isCmiste () {
      return this.userJob === 'CMI'
    }
  },
  methods: {},
  async beforeMount () {
    let codes = ['honoraire_charge_de', 'mandat_statut', 'mandat_type']
    codes = codes.map(function (x) {
      return x.toUpperCase()
    })
    const definitionDonneeListeeByCode = await getDefinitionDonneeListeeByCode({ codes: codes })
    if (definitionDonneeListeeByCode.type == 'error') {
      this.$message({ message: this.$t('error.found'), type: 'error' })
      this.loading = false
      return false
    }
    this.$emit('ddList-update', definitionDonneeListeeByCode)
  }
}
</script>
